import React from 'react';
import StaffForm from '../../Components/Staff/StaffForm';

export default function ConsultantForm() {
  return (
    <StaffForm
      role="consultant"
      title="Consultant"
      returnUrl="/consultant"
    />
  );
}
